import React, { useMemo } from "react";

import {
  AccountBookOutlined,
  AuditOutlined,
  FileDoneOutlined,
  FileSearchOutlined,
  FileTextOutlined,
  FolderOpenOutlined,
  FormOutlined,
  HistoryOutlined,
  HomeOutlined,
  InboxOutlined,
  MoneyCollectOutlined,
  NotificationOutlined,
  SafetyCertificateOutlined,
  SendOutlined,
  SettingOutlined,
  ShopOutlined,
  StopOutlined,
  SyncOutlined,
  TagsOutlined,
  TeamOutlined,
  ToolOutlined,
  TransactionOutlined,
  UserOutlined,
  WalletOutlined,
  WarningOutlined
} from "@ant-design/icons";
import { Spin } from "antd";
import { useLocation, useNavigate } from "react-router-dom";

import Routers from "../constants/routers";
import { useUser } from "../context/UserContext";
import "./Sidebar.css";

const menuIcons = {
  "application-intake": InboxOutlined,
  "application-management": AuditOutlined,
  "guarantee-contract": SafetyCertificateOutlined,
  "contract-renewal": SyncOutlined,
  "variable-cost-application": FileSearchOutlined,
  "variable-cost-registration": FormOutlined,
  delinquent: WarningOutlined,
  affiliate: ShopOutlined,
  "affiliate-application": FileDoneOutlined,
  invoice: AccountBookOutlined,
  item: TagsOutlined,
  "document-template": FileTextOutlined,
  equipment: ToolOutlined,
  "inclusive-contract": FolderOpenOutlined,
  subrogation: TransactionOutlined,
  "initial-billing": MoneyCollectOutlined,
  finance: WalletOutlined,
  "owner-remittance": SendOutlined,
  settings: SettingOutlined,
  staff: TeamOutlined,
  building: HomeOutlined,
  owner: UserOutlined,
  cancellation: StopOutlined,
  notice: NotificationOutlined,
  "notification-history": HistoryOutlined
} as const;

type MenuIconName = keyof typeof menuIcons;

export interface MenuItem {
  id: string;
  title: string;
  icon: MenuIconName;
  path: string;
  children?: MenuItem[];
  code?: string;
}

export const menuItems: MenuItem[] = [
  // {
  //   id: "dashboard",
  //   title: "ダッシュボード",
  //   icon: "dashboard",
  //   path: Routers.Dashboard,
  // },
  {
    id: "application-intake",
    title: "申込取込",
    icon: "application-intake",
    path: Routers.ApplicationIntake,
    code: "application_entry"
  },
  {
    id: "applications",
    title: "申込管理",
    icon: "application-management",
    path: Routers.Applications,
    code: "application_mgmt"
  },
  {
    id: "contracts",
    title: "家賃保証契約管理",
    icon: "guarantee-contract",
    path: Routers.Contracts,
    code: "guarantee_contract"
  },
  {
    id: "contract-renewals",
    title: "更新管理",
    icon: "contract-renewal",
    path: Routers.ContractRenewals,
    code: "guarantee_contract"
  },
  // {
  //   id: "contracts-poppo",
  //   title: "(旧)契約 ",
  //   icon: "contract",
  //   path: "/contracts-poppo"
  // },
  {
    id: "variable-cost-applications",
    title: "変動費申請管理",
    icon: "variable-cost-application",
    path: Routers.VariableCostApplications,
    code: "variable_expense_request"
  },
  {
    id: "variable-cost-registration",
    title: "変動費登録",
    icon: "variable-cost-registration",
    path: Routers.VariableCostRegistration,
    code: "variable_expense_entry"
  },
  {
    id: "delinquents",
    title: "滞納者管理",
    icon: "delinquent",
    path: Routers.Delinquents,
    code: "old_delinquent_mgmt"
  },
  {
    id: "delinquents-poppo",
    title: "(旧)滞納者管理",
    icon: "delinquent",
    path: Routers.DelinquentsPoppo,
    code: "old_delinquent_mgmt"
  },
  // {
  //   id: "equipment-warranty",
  //   title: "設備保証契約",
  //   icon: "equipment",
  //   path: Routers.EquipmentWarranty,
  //   code: "equipment_guarantee",
  // },
  // {
  //   id: "customers",
  //   title: "顧客管理",
  //   icon: "customers",
  //   path: Routers.Customers,
  //   code: "customer_mgmt",
  // },
  {
    id: "affiliates",
    title: "加盟店管理",
    icon: "affiliate",
    path: Routers.Affiliates,
    code: "shop_mgmt"
  },
  {
    id: "affiliate-applications",
    title: "加盟店申請管理",
    icon: "affiliate-application",
    path: Routers.AffiliateApplications,
    code: "shop_mgmt"
  },
  {
    id: "invoices",
    title: "請求書管理",
    icon: "invoice",
    path: Routers.Invoices,
    code: "shop_mgmt"
  },
  {
    id: "items",
    title: "商品管理",
    icon: "item",
    path: Routers.Items,
    code: "product_mgmt"
  },
  {
    id: "document-templates",
    title: "帳票管理",
    icon: "document-template",
    path: Routers.DocumentTemplates,
    code: "product_mgmt"
  },
  {
    id: "equipment-guarantee-contract",
    title: "(旧)設備保証",
    icon: "equipment",
    path: Routers.EquipmentGuaranteeContract,
    code: "guarantee_contract"
  },
  // {
  //   id: "inclusive-contract-application",
  //   title: "包括契約登録",
  //   icon: "inclusive-contract-application",
  //   path: Routers.InclusiveContractApplication,
  //   code: "comprehensive_contract_entry",
  // },
  {
    id: "inclusive-contract-application-management",
    title: "包括契約管理",
    icon: "inclusive-contract",
    path: Routers.InclusiveContractApplicationManagement,
    code: "comprehensive_request_mgmt"
  },
  {
    id: "subrogation-payment",
    title: "代位弁済請求申請管理",
    icon: "subrogation",
    path: Routers.SubrogationPayment,
    code: "subrogation_request_mgmt"
  },
  // {
  //   id: "subrogation-request-register",
  //   title: "代位弁済請求登録",
  //   icon: "",
  //   path: Routers.SubrogationRequestRegister,
  //   code: "subrogation_request_entry",
  // },
  {
    id: "initial-billing",
    title: "(旧)初回請求管理",
    icon: "initial-billing",
    path: Routers.InitialBilling,
    code: "old_initial_claim_mgmt"
  },
  // {
  //   id: "payment-management",
  //   title: "入出金管理",
  //   icon: "currency",
  //   path: Routers.PaymentManagement,
  //   code: "cashflow_mgmt",
  // },
  {
    id: "finance",
    title: "(旧)入出金管理",
    icon: "finance",
    path: Routers.Finance,
    code: "old_cashflow_mgmt"
  },
  {
    id: "owner-remittance",
    title: "(旧)オーナー送金",
    icon: "owner-remittance",
    path: Routers.OwnerRemittance,
    code: "old_owner_transfer"
  },
  // {
  //   id: "communication",
  //   title: "(旧)コミュニケーション",
  //   icon: "communication",
  //   path: "/communication"
  // },
  // {
  //   id: "itanji-integration",
  //   title: "Itanji連携",
  //   icon: "integration",
  //   path: "/itanji-integration"
  // },
  // {
  //   id: "blanket-contracts",
  //   title: "包括契約",
  //   icon: "document",
  //   path: Routers.BlanketContracts,
  //   code: "comprehensive_request_mgmt",
  // },
  {
    id: "settings",
    title: "(旧)システム設定",
    icon: "settings",
    path: Routers.Settings,
    code: "old_system_settings"
  },
  {
    id: "staff",
    title: "スタッフ",
    icon: "staff",
    path: Routers.Staff,
    code: "old_staff"
  },
  {
    id: "buildings",
    title: "(旧)物件管理",
    icon: "building",
    path: Routers.Buildings,
    code: "old_property_mgmt"
  },
  {
    id: "owners",
    title: "(旧)貸主管理",
    icon: "owner",
    path: Routers.Owners,
    code: "old_landlord_mgmt"
  },
  {
    id: "cancel-contract",
    title: "解約申請一覧",
    icon: "cancellation",
    path: Routers.CancelContracts,
    code: "contract_cancel_list"
  },
  {
    id: "notices",
    title: "お知らせ管理",
    icon: "notice",
    path: Routers.Notices,
    code: "notification_mgmt"
  },
  {
    id: "notification-deliveries",
    title: "通知送信履歴",
    icon: "notification-history",
    path: Routers.NotificationDeliveries,
    code: "notification_mgmt"
  },
  {
    id: "system-settings",
    title: "システム設定",
    icon: "settings",
    path: Routers.SystemSettings,
    code: "old_system_settings"
  }
];

export const isMenuItemActive = (pathname: string, item: MenuItem) => {
  if (item.id !== "affiliate-applications") return pathname === item.path;

  return [Routers.AffiliateApplications, Routers.AffiliateInquiries, Routers.ShopRegistrationApplies].some(
    (path) => pathname === path || pathname.startsWith(`${path}/`)
  );
};

const Sidebar: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { userPermission } = useUser();
  const handleMenuClick = (path: string) => {
    navigate(path);
  };
  const visibleMenuItems = useMemo(() => {
    if (!userPermission) return [];

    return menuItems.filter((item) => {
      // menu without permission → always display
      if (!item?.code) return true;

      const permission = userPermission.find((p: any) => p?.code === item?.code);

      // menu item that permission = null or level = 3 → hide
      if (!permission || !permission.level || permission.level === 3) {
        return false;
      }

      return true;
    });
  }, [userPermission]);

  const renderIcon = (iconName: MenuIconName) => {
    const Icon = menuIcons[iconName];
    return <Icon aria-hidden="true" />;
  };

  return (
    <div className="sidebar">
      <nav className="sidebar-nav">
        <div className="nav-section">
          <div className="nav-section-title">メインメニュー</div>
          <ul className="nav-list">
            {userPermission && userPermission?.length > 0 && visibleMenuItems ? (
              visibleMenuItems?.map((item) => (
                <li key={item.id} className="nav-item">
                  <button
                    className={`nav-link ${isMenuItemActive(location.pathname, item) ? "active" : ""}`}
                    onClick={() => handleMenuClick(item.path)}
                  >
                    <span className="nav-icon">{renderIcon(item.icon)}</span>
                    <span className="nav-text">{item.title}</span>
                  </button>
                </li>
              ))
            ) : (
              <div className="w-full h-[500px] flex items-center justify-center">
                <Spin />
              </div>
            )}
          </ul>
        </div>

        {/* <div className="nav-section">
          <div className="nav-section-title">その他</div>
          <ul className="nav-list">
            <li className="nav-item">
              <button className="nav-link">
                <span className="nav-icon">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 17h-2v-2h2v2zm2.07-7.75l-.9.92C13.45 12.9 13 13.5 13 15h-2v-.5c0-1.1.45-2.1 1.17-2.83l1.24-1.26c.37-.36.59-.86.59-1.41 0-1.1-.9-2-2-2s-2 .9-2 2H8c0-2.21 1.79-4 4-4s4 1.79 4 4c0 .88-.36 1.68-.93 2.25z" />
                  </svg>
                </span>
                <span className="nav-text">ヘルプ</span>
              </button>
            </li>
          </ul>
        </div> */}
      </nav>
    </div>
  );
};

export default Sidebar;
